var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.5625V0H1.6875C0.752344 0 0 0.752344 0 1.6875V34.3125C0 35.2477 0.752344 36 1.6875 36H25.3125C26.2477 36 27 35.2477 27 34.3125V11.25H17.4375C16.5094 11.25 15.75 10.4906 15.75 9.5625ZM20.25 26.1562C20.25 26.6203 19.8703 27 19.4062 27H7.59375C7.12969 27 6.75 26.6203 6.75 26.1562V25.5938C6.75 25.1297 7.12969 24.75 7.59375 24.75H19.4062C19.8703 24.75 20.25 25.1297 20.25 25.5938V26.1562ZM20.25 21.6562C20.25 22.1203 19.8703 22.5 19.4062 22.5H7.59375C7.12969 22.5 6.75 22.1203 6.75 21.6562V21.0938C6.75 20.6297 7.12969 20.25 7.59375 20.25H19.4062C19.8703 20.25 20.25 20.6297 20.25 21.0938V21.6562ZM20.25 16.5938V17.1562C20.25 17.6203 19.8703 18 19.4062 18H7.59375C7.12969 18 6.75 17.6203 6.75 17.1562V16.5938C6.75 16.1297 7.12969 15.75 7.59375 15.75H19.4062C19.8703 15.75 20.25 16.1297 20.25 16.5938ZM27 8.57109V9H18V0H18.4289C18.8789 0 19.3078 0.175781 19.6242 0.492188L26.5078 7.38281C26.8242 7.69922 27 8.12813 27 8.57109Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/ip.742cc5baaab66b3df3354a2d69c6a62a.svg";
export { ForwardRef as ReactComponent };